import { PageList } from '.'
import { lazy } from 'react'

export enum PagesEnum {
    Home = 'Home',
    Generic = 'Generic',
    LocationsHub = 'LocationsHub',
    Location = 'Location',
    Contact = 'Contact',
    MovieListings = 'MovieListings',
    MovieDetails = 'MovieDetails',
    ForgotPassword = 'ForgotPassword',
    ResetPassword = 'ResetPassword',
    Login = 'Login',
    SignUp = 'SignUp',
    MemberOverview = 'MemberOverview',
    MemberProfile = 'MemberProfile',
    MemberCardWallet = 'MemberCardWallet',
    BlogLanding = 'BlogLanding',
    BlogPost = 'BlogPost',
    BalanceChecker = 'BalanceChecker',
    ErrorNotFound = 'ErrorNotFound',
    FoodAndDrinks = 'FoodAndDrinks',
}

export const Pages: PageList = {
    Home: {
        component: lazy(() => import('./home')),
        urls: ['/'],
    },
    Generic: {
        component: lazy(() => import('./generic')),
        urls: ['/'],
    },
    LocationsHub: {
        component: lazy(() => import('./locationsHub')),
        urls: ['/'],
    },
    Location: {
        component: lazy(() => import('./location')),
        urls: ['/'],
    },
    Contact: {
        component: lazy(() => import('./contact')),
        urls: ['/'],
    },
    MovieListings: {
        component: lazy(() => import('./movieListings')),
        urls: ['/'],
    },
    MovieDetails: {
        component: lazy(() => import('./movieDetails')),
        urls: ['/'],
        parent: PagesEnum.MovieListings,
        params: ['filmName', 'filmId'],
        customAlias: 'movieDetails',
    },
    Login: {
        component: lazy(() => import('./login')),
        urls: ['/'],
    },
    SignUp: {
        component: lazy(() => import('./signUp')),
        urls: ['/'],
    },
    ForgotPassword: {
        component: lazy(() => import('./membership/forgotPassword')),
        urls: ['/'],
    },
    ResetPassword: {
        component: lazy(() => import('./membership/completePasswordResetForm')),
        urls: ['/'],
    },
    MemberOverview: {
        component: lazy(() => import('./membership/overview')),
        urls: ['/'],
    },
    MemberProfile: {
        component: lazy(() => import('./membership/profile')),
        urls: ['/'],
    },
    MemberCardWallet: {
        component: lazy(() => import('./membership/memberCardWallet')),
        urls: ['/'],
    },
    BlogLanding: {
        component: lazy(() => import('./blogLanding')),
        urls: ['/'],
    },
    BlogPost: {
        component: lazy(() => import('./blogPost')),
        urls: ['/'],
    },
    BalanceChecker: {
        component: lazy(() => import('./balanceChecker')),
        urls: ['/'],
    },
    ErrorNotFound: {
        component: lazy(() => import('./404')),
        urls: ['/'],
    },
    FoodAndDrinks: {
        component: lazy(() => import('./foodAndDrinks')),
        urls: ['/'],
    },
}

export const PagesNames = (includeChildPages = false, includeSubPages = false): PagesEnum[] => {
    let pages = []
    for (let page in PagesEnum) {
        if (includeChildPages || !Pages[page as PagesEnum].parent) pages.push(page)
        if (includeSubPages && Pages[page as PagesEnum].subPages && Pages[page as PagesEnum].subPages.length)
            Pages[page as PagesEnum].subPages.forEach(subPage => pages.push(subPage.alias))
    }
    return pages
}

export const PagesNamesToExclude = (): PagesEnum[] => {
    let pages = []
    for (let page in PagesEnum) {
        if (!!Pages[page as PagesEnum].parent) pages.push(page)
    }
    return pages
}
